/**
 * Internal staff gate used for experimental features (AI chat, debug info).
 * @param {string|null|undefined} email
 * @returns {boolean}
 */
export function isSportplatzMediaEmail(email) {
  if (!email || typeof email !== 'string') {
    return false;
  }
  return email.toLowerCase().endsWith('@sportplatz-media.com');
}
